import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Routes } from './Routes';

interface Props {
  isAuthenticated: boolean;
}

export const NotAuthRoute: FC<Props> = ({ isAuthenticated }) => {
  return !isAuthenticated ? <Outlet /> : <Navigate to={Routes.ASSETS.ROOT} />;
};
